import { render, staticRenderFns } from "./ProsList.vue?vue&type=template&id=03346fff&"
import script from "./ProsList.vue?vue&type=script&lang=js&"
export * from "./ProsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports